module.exports = __webpack_public_path__ + "8a5356e9/img/archive-icon.0a6a9de3.svg";